// 联系我们
<template>
  <div class="main">
    <div class="banana">
      <img src="../assets/img/banner/画板 3 拷贝.png" alt />
    </div>
    <div class="center">
      <div class="nav">
        <p>
          当前位置：
          <span @click="shouye" class="navvv">首页</span> > 联系我们
        </p>
      </div>
      <div class="lxwm">
        <div class="map">
          <el-amap :center="center" :zoom="zoom" id="container" :events="events">
            <el-amap-marker :position="center" :label="label"></el-amap-marker>
          </el-amap>
        </div>
        <div class="right">
          <h1>
            <span class="bluue">联系我们</span> CONTACT US
          </h1>
          <!-- <p>
            <span>
              <img src="../assets/img/icon/座机@2x.png" class="oneImg" />
            </span>
            业务咨询：400-001-6911
          </p> -->
          <p>
            <span>
              <img src="../assets/img/icon/手机@2x.png" class="twoImg" />
            </span>
            客服电话：0371-65353150
          </p>
          <p>
            <span>
              <img src="../assets/img/icon/地址@2x.png" class="threeImg" />
            </span>
            地址：河南省郑州市郑东新区郑开大道89号河南建设大厦
          </p>
        </div>
      </div>

      <div class="message">
        <h1>
          <span class="bluue">在线留言</span> MESSAGE
        </h1>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名" prop="name">
            <el-col :span="6">
              <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-col :span="6">
              <el-input v-model="ruleForm.phone" placeholder="请输入电话"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-col :span="6">
              <el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="留言" class="messg">
            <el-input type="textarea" v-model="ruleForm.desc" class="msg"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" class="submitt">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      center: [113.862161, 34.772913],
      zoom: 15,
      label: {
        content: "河南省建协工程咨询有限公司",
        offset: [10, 12],
      },
      ruleForm: {
        name: "",
        phone: "",
        email: "",
        desc: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
      },
    };
  },
  methods: {
    shouye() {
      this.$router.replace("/");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!');
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 初始化地图
    initMap(map) {
      var map = new AMap.Map("container", {
        zoomEnable: true, //是否禁止缩放
        zoom: 12, //缩放比例
        dragEnable: false, //禁止拖动
        cursor: "hand", // 鼠标在地图上的表现形式，小手
      });
      // 初始化工具条
      map.plugin(["AMap.ToolBar"], function () {
        map.addControl(new AMap.ToolBar());
      });
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
.main {
  width: 100%;
  font-size: 16px;
  .banana {
    width: 100%;
    // background: url("../assets/img/banner/画板 3 拷贝.png") center no-repeat;
    // background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .center {
    width: 1160px;
    margin: 0 auto;
    // padding: 0px 360px;
    box-sizing: border-box;
    overflow: hidden;
    .nav {
      width: 100%;
      border-bottom: 1px solid #a0a0a0;
      opacity: 1;
      font-size: 12px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #666666;
      line-height: 36px;
      margin-bottom: 50px;
    }
    .lxwm {
      width: 100%;
      height: 304px;
      position: relative;
      margin-bottom: 114px;
      .map {
        width: 551px;
        height: 304px;
        background: brown;
        position: absolute;
        top: 0px;
        left: 0px;
      }
      .right {
        width: 500px;
        height: 100%;
        position: absolute;
        top: 0px;
        right: 35px;
        h1 {
          span {
            opacity: 1;
            font-size: 30px;
            font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
            font-weight: 700;
            text-align: justifyLeft;
            color: #4279db;
            line-height: 75px;
            letter-spacing: 2px;
            margin-bottom: 60px;
          }
          opacity: 1;
          font-size: 30px;
          font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
          font-weight: 700;
          text-align: justifyLeft;
          color: black;
          line-height: 75px;
          letter-spacing: 5px;
        }
      }
      p {
        width: 100%;
        height: 35px;
        opacity: 1;
        font-size: 16px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: justifyLeft;
        color: #333333;
        line-height: 75px;
        letter-spacing: 2px;
        padding-left: 35px;
        position: relative;
        span {
          display: block;
          width: 19px;
          height: 15px;
          position: absolute;
          left: 0px;
          top: 2px;
          .oneImg {
            width: 19px;
            height: 17px;
          }
          .twoImg {
            width: 13px;
            height: 20px;
            margin-left: 2px;
          }
          .threeImg {
            width: 13px;
            height: 18px;
            margin-left: 2px;
          }
        }
      }
    }
    .message {
      width: 100%;
      height: 430px;
      margin-bottom: 200px;
      h1 {
        span {
          opacity: 1;
          font-size: 30px;
          font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
          font-weight: 700;
          text-align: center;
          color: #4279db;
          line-height: 75px;
          letter-spacing: 2px;
          margin-bottom: 60px;
        }
        opacity: 1;
        font-size: 30px;
        font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
        font-weight: 700;
        text-align: center;
        color: black;
        line-height: 75px;
        letter-spacing: 5px;
      }
    }
  }
}
.el-input {
  float: left !important;
}
.submitt {
  width: 33% !important;
  margin-left: 30% !important;
}
.is-required {
  width: 400px !important;
  margin: 40px 240px !important;
  // float: left !important;
}
.el-form-item__content {
  width: 40px !important;
}
.el-form-item__content:nth-last-of-type(1) {
  width: 500px !important;
}
.el-input__inner {
  width: 35px !important;
}
.el-col-6 {
  width: 500px;
}
.messg {
  margin-left: 240px !important;
}
.el-textarea {
  width: 61% !important;
}
</style>
